// src/components/loot.js
export const loot = [
    {
      id: 1,
      name: "Rusty Sword",
      type: "weapon",
      atk: 5,
      def: 0,
      hp: 0,
      damage: 10,
      crit_chance: 0.05,
      crit_damage: 1.5,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 5,
      rarity: "Common",
      lore: "A weathered blade from a fallen Eryndor soldier.",
      zone_id: 1,
      monster_id: 1,
      level_requirement: 1,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 2,
      name: "Leather Armor",
      type: "armor",
      atk: 0,
      def: 5,
      hp: 10,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.02,
      status_resist: 0.05,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 5,
      rarity: "Common",
      lore: "Tattered armor scavenged from the wastes.",
      zone_id: 3,
      monster_id: 5,
      level_requirement: 1,
      range: 0,
      equip_slot: "chest",
    },
    {
      id: 3,
      name: "Healing Potion",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 20,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 3,
      rarity: "Common",
      lore: "A basic potion brewed from oasis herbs.",
      zone_id: 31,
      monster_id: 61,
      level_requirement: 1,
      range: 0,
      equip_slot: "none",
    },
    {
      id: 4,
      name: "Ectoplasm Bomb",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 15,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 10,
      rarity: "Uncommon",
      lore: "A volatile concoction of trapped spirits.",
      zone_id: 5,
      monster_id: 33,
      level_requirement: 3,
      range: 2,
      equip_slot: "none",
    },
    {
      id: 5,
      name: "Shadow Ring",
      type: "accessory",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 0,
      crit_chance: 0.10,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 5,
      dodge_chance: 0.05,
      status_resist: 0.0,
      luck: 2,
      drop_chance: 0.15,
      ectoplasm_cost: 15,
      rarity: "Rare",
      lore: "A ring imbued with the essence of the Veil.",
      zone_id: 10,
      monster_id: 19,
      level_requirement: 5,
      range: 0,
      equip_slot: "ring",
    },
    {
      id: 6,
      name: "Bone Dagger",
      type: "weapon",
      atk: 8,
      def: 0,
      hp: 0,
      damage: 12,
      crit_chance: 0.08,
      crit_damage: 1.6,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 6,
      rarity: "Common",
      lore: "A dagger carved from the bones of a fallen soldier in the Shattered Vestibule.",
      zone_id: 1,
      monster_id: 1,
      level_requirement: 2,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 7,
      name: "Tattered Cloak",
      type: "armor",
      atk: 0,
      def: 3,
      hp: 8,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.01,
      status_resist: 0.03,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 4,
      rarity: "Common",
      lore: "A worn cloak found in the Entry Hall, offering minimal protection.",
      zone_id: 1,
      monster_id: 2,
      level_requirement: 1,
      range: 0,
      equip_slot: "chest",
    },
    {
      id: 8,
      name: "Minor Mana Shard",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 10,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 3,
      rarity: "Common",
      lore: "A small shard that restores a bit of mana, found in the Crypt.",
      zone_id: 1,
      monster_id: 3,
      level_requirement: 1,
      range: 0,
      equip_slot: "none",
    },
    {
      id: 9,
      name: "Waterlogged Blade",
      type: "weapon",
      atk: 10,
      def: 0,
      hp: 0,
      damage: 15,
      crit_chance: 0.06,
      crit_damage: 1.6,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 8,
      rarity: "Common",
      lore: "A blade rusted by the waters of the Flooded Catacombs.",
      zone_id: 2,
      monster_id: 9,
      level_requirement: 6,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 10,
      name: "Siren’s Charm",
      type: "accessory",
      atk: 0,
      def: 2,
      hp: 5,
      damage: 0,
      crit_chance: 0.05,
      crit_damage: 1.5,
      mana: 5,
      max_mana: 0,
      dodge_chance: 0.02,
      status_resist: 0.05,
      luck: 1,
      drop_chance: 0.2,
      ectoplasm_cost: 12,
      rarity: "Uncommon",
      lore: "A charm dropped by a Spectral Siren, imbued with her haunting song.",
      zone_id: 2,
      monster_id: 10,
      level_requirement: 6,
      range: 0,
      equip_slot: "neck",
    },
    {
      id: 11,
      name: "Ashen Cloak",
      type: "armor",
      atk: 0,
      def: 6,
      hp: 12,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.02,
      status_resist: 0.05,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 6,
      rarity: "Common",
      lore: "A cloak covered in ash, scavenged from the Cursed Expanse Wastes.",
      zone_id: 3,
      monster_id: 17,
      level_requirement: 4,
      range: 0,
      equip_slot: "chest",
    },
    {
      id: 12,
      name: "Veil Shard",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 15,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 8,
      rarity: "Uncommon",
      lore: "A shard of Veil energy, dropped by a Veil Stalker in the Wastes.",
      zone_id: 3,
      monster_id: 18,
      level_requirement: 4,
      range: 0,
      equip_slot: "none",
    },
    {
      id: 13,
      name: "Skeletal Bow",
      type: "weapon",
      atk: 7,
      def: 0,
      hp: 0,
      damage: 12,
      crit_chance: 0.07,
      crit_damage: 1.5,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 7,
      rarity: "Common",
      lore: "A bow crafted from bones, used by a Skeletal Archer in the Guarded Crypts.",
      zone_id: 4,
      monster_id: 25,
      level_requirement: 4,
      range: 3,
      equip_slot: "main_hand",
    },
    {
      id: 14,
      name: "Shade’s Veil",
      type: "armor",
      atk: 0,
      def: 4,
      hp: 10,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.03,
      status_resist: 0.05,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 5,
      rarity: "Common",
      lore: "A veil worn by a Restless Shade, offering slight protection.",
      zone_id: 4,
      monster_id: 26,
      level_requirement: 4,
      range: 0,
      equip_slot: "head",
    },
    {
      id: 15,
      name: "Mirror Shard",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 10,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 5,
      rarity: "Common",
      lore: "A shard of a broken mirror, dropped by a Mirror Phantom in the Echoing Gallery.",
      zone_id: 5,
      monster_id: 33,
      level_requirement: 6,
      range: 2,
      equip_slot: "none",
    },
    {
      id: 16,
      name: "Echoing Amulet",
      type: "accessory",
      atk: 0,
      def: 3,
      hp: 8,
      damage: 0,
      crit_chance: 0.05,
      crit_damage: 1.5,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.02,
      status_resist: 0.05,
      luck: 1,
      drop_chance: 0.2,
      ectoplasm_cost: 10,
      rarity: "Uncommon",
      lore: "An amulet that echoes with ghostly whispers, dropped by an Echo Wraith.",
      zone_id: 5,
      monster_id: 34,
      level_requirement: 6,
      range: 0,
      equip_slot: "neck",
    },
    {
      id: 17,
      name: "Royal Blade",
      type: "weapon",
      atk: 12,
      def: 0,
      hp: 0,
      damage: 18,
      crit_chance: 0.08,
      crit_damage: 1.7,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 10,
      rarity: "Common",
      lore: "A blade once wielded by a Royal Skeleton in the Audience Chamber.",
      zone_id: 6,
      monster_id: 41,
      level_requirement: 8,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 18,
      name: "Herald’s Cloak",
      type: "armor",
      atk: 0,
      def: 8,
      hp: 15,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.03,
      status_resist: 0.10,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 12,
      rarity: "Uncommon",
      lore: "A cloak worn by a Spectral Herald, imbued with ghostly energy.",
      zone_id: 6,
      monster_id: 42,
      level_requirement: 8,
      range: 0,
      equip_slot: "chest",
    },
    {
      id: 19,
      name: "Tidal Dagger",
      type: "weapon",
      atk: 15,
      def: 0,
      hp: 0,
      damage: 20,
      crit_chance: 0.10,
      crit_damage: 1.8,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 10,
      rarity: "Common",
      lore: "A dagger washed in the tides of the Tidal Tombs.",
      zone_id: 7,
      monster_id: 49,
      level_requirement: 9,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 20,
      name: "Sea Wraith’s Veil",
      type: "armor",
      atk: 0,
      def: 10,
      hp: 20,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.04,
      status_resist: 0.10,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 15,
      rarity: "Uncommon",
      lore: "A veil dropped by a Sea Wraith, shimmering with watery energy.",
      zone_id: 7,
      monster_id: 50,
      level_requirement: 9,
      range: 0,
      equip_slot: "head",
    },
    {
      id: 21,
      name: "Ink-Stained Staff",
      type: "weapon",
      atk: 10,
      def: 0,
      hp: 0,
      damage: 15,
      crit_chance: 0.08,
      crit_damage: 1.6,
      mana: 5,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 12,
      rarity: "Common",
      lore: "A staff stained with cursed ink, dropped by an Ink Phantom in the Sunken Library.",
      zone_id: 8,
      monster_id: 57,
      level_requirement: 10,
      range: 2,
      equip_slot: "main_hand",
    },
    {
      id: 22,
      name: "Tome Guardian’s Shield",
      type: "armor",
      atk: 0,
      def: 12,
      hp: 25,
      damage: 0,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.05,
      status_resist: 0.15,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 15,
      rarity: "Uncommon",
      lore: "A shield used by a Tome Guardian to protect the Silent Archives.",
      zone_id: 8,
      monster_id: 58,
      level_requirement: 10,
      range: 0,
      equip_slot: "off_hand",
    },
    {
      id: 23,
      name: "Frosted Blade",
      type: "weapon",
      atk: 12,
      def: 0,
      hp: 0,
      damage: 18,
      crit_chance: 0.09,
      crit_damage: 1.7,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 12,
      rarity: "Common",
      lore: "A blade chilled by the icy waters of the Abyssal Cistern.",
      zone_id: 9,
      monster_id: 65,
      level_requirement: 11,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 24,
      name: "Ice Elemental Core",
      type: "consumable",
      atk: 0,
      def: 0,
      hp: 0,
      damage: 20,
      crit_chance: 0.0,
      crit_damage: 0.0,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.2,
      ectoplasm_cost: 10,
      rarity: "Uncommon",
      lore: "A core dropped by an Ice Elemental, radiating cold energy.",
      zone_id: 9,
      monster_id: 66,
      level_requirement: 11,
      range: 2,
      equip_slot: "none",
    },
    {
      id: 25,
      name: "Obsidian Hammer",
      type: "weapon",
      atk: 15,
      def: 0,
      hp: 0,
      damage: 22,
      crit_chance: 0.10,
      crit_damage: 1.8,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.0,
      luck: 0,
      drop_chance: 0.3,
      ectoplasm_cost: 15,
      rarity: "Common",
      lore: "A hammer forged in the Obsidian Forges, still warm to the touch.",
      zone_id: 10,
      monster_id: 73,
      level_requirement: 12,
      range: 1,
      equip_slot: "main_hand",
    },
    {
      id: 26,
      name: "Ember Pendant",
      type: "accessory",
      atk: 0,
      def: 5,
      hp: 10,
      damage: 0,
      crit_chance: 0.05,
      crit_damage: 1.5,
      mana: 0,
      max_mana: 0,
      dodge_chance: 0.0,
      status_resist: 0.10,
      luck: 2,
      drop_chance: 0.2,
      ectoplasm_cost: 15,
      rarity: "Uncommon",
      lore: "A pendant glowing with ember energy, dropped by an Ember Spirit.",
      zone_id: 10,
      monster_id: 74,
      level_requirement: 12,
      range: 0,
      equip_slot: "neck",
    },
    {
        id: 27,
        name: "Molten Gauntlets",
        type: "armor",
        atk: 0,
        def: 15,
        hp: 30,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.15,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 18,
        rarity: "Uncommon",
        lore: "Gauntlets forged in the Molten Crucible, still glowing with heat.",
        zone_id: 11,
        monster_id: 81,
        level_requirement: 13,
        range: 0,
        equip_slot: "hands",
      },
      {
        id: 28,
        name: "Iron Construct Core",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 25,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 12,
        rarity: "Uncommon",
        lore: "A core from an Iron Construct, radiating residual heat.",
        zone_id: 11,
        monster_id: 82,
        level_requirement: 13,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 29,
        name: "Ashen Spear",
        type: "weapon",
        atk: 16,
        def: 0,
        hp: 0,
        damage: 22,
        crit_chance: 0.09,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 14,
        rarity: "Common",
        lore: "A spear coated in ash, used by an Ash Hound in the Ashen Foundry.",
        zone_id: 12,
        monster_id: 89,
        level_requirement: 14,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 30,
        name: "Smelter’s Hood",
        type: "armor",
        atk: 0,
        def: 12,
        hp: 25,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.04,
        status_resist: 0.10,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "A hood worn by a Smelter Shade, stained with soot.",
        zone_id: 12,
        monster_id: 90,
        level_requirement: 14,
        range: 0,
        equip_slot: "head",
      },
      {
        id: 31,
        name: "Bloodstone Mace",
        type: "weapon",
        atk: 18,
        def: 0,
        hp: 0,
        damage: 25,
        crit_chance: 0.10,
        crit_damage: 1.8,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 15,
        rarity: "Common",
        lore: "A mace carved from bloodstone, wielded by a Bloodstone Golem.",
        zone_id: 13,
        monster_id: 97,
        level_requirement: 15,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 32,
        name: "Veil Bat Wing",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 20,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 10,
        rarity: "Uncommon",
        lore: "A wing from a Veil Bat, infused with Veil energy.",
        zone_id: 13,
        monster_id: 98,
        level_requirement: 15,
        range: 0,
        equip_slot: "none",
      },
      {
        id: 33,
        name: "Crystal Staff",
        type: "weapon",
        atk: 15,
        def: 0,
        hp: 0,
        damage: 20,
        crit_chance: 0.08,
        crit_damage: 1.6,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 12,
        rarity: "Common",
        lore: "A staff made of crystal, used by a Crystal Guardian in the Veilspires.",
        zone_id: 14,
        monster_id: 105,
        level_requirement: 16,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 34,
        name: "Veil Sprite Charm",
        type: "accessory",
        atk: 0,
        def: 5,
        hp: 10,
        damage: 0,
        crit_chance: 0.06,
        crit_damage: 1.6,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.10,
        luck: 2,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "A charm glowing with Veil energy, dropped by a Veil Sprite.",
        zone_id: 14,
        monster_id: 106,
        level_requirement: 16,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 35,
        name: "Soulrift Blade",
        type: "weapon",
        atk: 20,
        def: 0,
        hp: 0,
        damage: 30,
        crit_chance: 0.12,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 15,
        rarity: "Common",
        lore: "A blade infused with soul energy, dropped by a Soul Wraith in the Nexus.",
        zone_id: 15,
        monster_id: 113,
        level_requirement: 17,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 36,
        name: "Ectoplasmic Armor",
        type: "armor",
        atk: 0,
        def: 18,
        hp: 35,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.15,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "Armor made from ectoplasm, dropped by an Ectoplasmic Horror.",
        zone_id: 15,
        monster_id: 114,
        level_requirement: 17,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 37,
        name: "Ethereal Dagger",
        type: "weapon",
        atk: 22,
        def: 0,
        hp: 0,
        damage: 32,
        crit_chance: 0.13,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 16,
        rarity: "Common",
        lore: "A dagger that shimmers with ethereal energy, dropped by a Bridge Specter.",
        zone_id: 16,
        monster_id: 121,
        level_requirement: 18,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 38,
        name: "Ethereal Cloak",
        type: "armor",
        atk: 0,
        def: 20,
        hp: 40,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.06,
        status_resist: 0.15,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A cloak that flows like the void winds, dropped by an Ethereal Stalker.",
        zone_id: 16,
        monster_id: 122,
        level_requirement: 18,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 39,
        name: "Prism Bow",
        type: "weapon",
        atk: 20,
        def: 0,
        hp: 0,
        damage: 30,
        crit_chance: 0.12,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 15,
        rarity: "Common",
        lore: "A bow that refracts light, dropped by a Crystal Sentinel in the Crystal Heart.",
        zone_id: 17,
        monster_id: 129,
        level_requirement: 19,
        range: 3,
        equip_slot: "main_hand",
      },
      {
        id: 40,
        name: "Prism Pendant",
        type: "accessory",
        atk: 0,
        def: 8,
        hp: 15,
        damage: 0,
        crit_chance: 0.07,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.10,
        luck: 3,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A pendant that glows with prismatic light, dropped by a Prism Wraith.",
        zone_id: 17,
        monster_id: 130,
        level_requirement: 19,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 41,
        name: "Rune Sword",
        type: "weapon",
        atk: 25,
        def: 0,
        hp: 0,
        damage: 35,
        crit_chance: 0.15,
        crit_damage: 2.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 18,
        rarity: "Common",
        lore: "A sword inscribed with runes, dropped by a Stone Guardian in the Trial Grounds.",
        zone_id: 18,
        monster_id: 137,
        level_requirement: 20,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 42,
        name: "Rune Knight’s Helm",
        type: "armor",
        atk: 0,
        def: 22,
        hp: 45,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.06,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A helm worn by a Rune Knight, inscribed with protective runes.",
        zone_id: 18,
        monster_id: 138,
        level_requirement: 20,
        range: 0,
        equip_slot: "head",
      },
      {
        id: 43,
        name: "King’s Scepter",
        type: "weapon",
        atk: 30,
        def: 0,
        hp: 0,
        damage: 40,
        crit_chance: 0.15,
        crit_damage: 2.0,
        mana: 10,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 2,
        drop_chance: 0.15,
        ectoplasm_cost: 50,
        rarity: "Rare",
        lore: "A scepter once wielded by the Crypt King, radiating dark power.",
        zone_id: 19,
        monster_id: 145,
        level_requirement: 21,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 44,
        name: "Royal Shade’s Cloak",
        type: "armor",
        atk: 0,
        def: 25,
        hp: 50,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.07,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A cloak worn by a Royal Shade, imbued with spectral energy.",
        zone_id: 19,
        monster_id: 146,
        level_requirement: 21,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 45,
        name: "Mirror Blade",
        type: "weapon",
        atk: 28,
        def: 0,
        hp: 0,
        damage: 38,
        crit_chance: 0.14,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 18,
        rarity: "Common",
        lore: "A blade that reflects light, dropped by a Mirror Doppelganger in the Mirror Maze.",
        zone_id: 20,
        monster_id: 39,
        level_requirement: 22,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 46,
        name: "Reflection Shard",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 30,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "A shard of a shattered mirror, dropped by a Reflection Wraith.",
        zone_id: 20,
        monster_id: 40,
        level_requirement: 22,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 47,
        name: "Soulforged Hammer",
        type: "weapon",
        atk: 30,
        def: 0,
        hp: 0,
        damage: 40,
        crit_chance: 0.15,
        crit_damage: 2.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 20,
        rarity: "Common",
        lore: "A hammer forged with souls, dropped by a Soulforger at the Soulforge Altar.",
        zone_id: 21,
        monster_id: 41,
        level_requirement: 23,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 48,
        name: "Ectoplasmic Robe",
        type: "armor",
        atk: 0,
        def: 28,
        hp: 55,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 10,
        max_mana: 0,
        dodge_chance: 0.07,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A robe woven with ectoplasm, dropped by an Ectoplasmic Priest.",
        zone_id: 21,
        monster_id: 42,
        level_requirement: 23,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 49,
        name: "Bone Axe",
        type: "weapon",
        atk: 32,
        def: 0,
        hp: 0,
        damage: 42,
        crit_chance: 0.16,
        crit_damage: 2.1,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 20,
        rarity: "Common",
        lore: "An axe made of bones, dropped by a Bone Construct in the Bone Labyrinth.",
        zone_id: 22,
        monster_id: 43,
        level_requirement: 24,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 50,
        name: "Skull Charm",
        type: "accessory",
        atk: 0,
        def: 10,
        hp: 20,
        damage: 0,
        crit_chance: 0.08,
        crit_damage: 1.8,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.15,
        luck: 3,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A charm made from a skull, dropped by a Skull Crawler.",
        zone_id: 22,
        monster_id: 44,
        level_requirement: 24,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 51,
        name: "Ectoplasmic Slime Bomb",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 35,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 15,
        rarity: "Common",
        lore: "A bomb made of ectoplasmic slime, dropped by an Ectoplasmic Slime in the Ectoplasm Veins.",
        zone_id: 23,
        monster_id: 45,
        level_requirement: 25,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 52,
        name: "Vein Guardian’s Shield",
        type: "armor",
        atk: 0,
        def: 30,
        hp: 60,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.08,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A shield used by a Vein Guardian to protect the ectoplasmic veins.",
        zone_id: 23,
        monster_id: 46,
        level_requirement: 25,
        range: 0,
        equip_slot: "off_hand",
      },
      {
        id: 53,
        name: "Vault Hammer",
        type: "weapon",
        atk: 35,
        def: 0,
        hp: 0,
        damage: 45,
        crit_chance: 0.16,
        crit_damage: 2.1,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 20,
        rarity: "Common",
        lore: "A hammer used by a Vault Golem to guard the Sealed Chambers.",
        zone_id: 24,
        monster_id: 47,
        level_requirement: 26,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 54,
        name: "Treasure Phantom’s Cloak",
        type: "armor",
        atk: 0,
        def: 32,
        hp: 65,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.08,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A cloak worn by a Treasure Phantom, shimmering with ghostly energy.",
        zone_id: 24,
        monster_id: 48,
        level_requirement: 26,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 55,
        name: "Golden Mace",
        type: "weapon",
        atk: 38,
        def: 0,
        hp: 0,
        damage: 48,
        crit_chance: 0.17,
        crit_damage: 2.2,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 22,
        rarity: "Common",
        lore: "A mace made of gold, wielded by a Gold Guardian in the Hidden Treasury.",
        zone_id: 25,
        monster_id: 49,
        level_requirement: 27,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 56,
        name: "Greed Spirit’s Ring",
        type: "accessory",
        atk: 0,
        def: 12,
        hp: 25,
        damage: 0,
        crit_chance: 0.09,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.15,
        luck: 4,
        drop_chance: 0.2,
        ectoplasm_cost: 30,
        rarity: "Uncommon",
        lore: "A ring imbued with greed, dropped by a Greed Spirit.",
        zone_id: 25,
        monster_id: 50,
        level_requirement: 27,
        range: 0,
        equip_slot: "ring",
      },
      {
        id: 57,
        name: "Earth Shard Blade",
        type: "weapon",
        atk: 40,
        def: 0,
        hp: 0,
        damage: 50,
        crit_chance: 0.18,
        crit_damage: 2.2,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 25,
        rarity: "Common",
        lore: "A blade forged from earth shards, dropped by an Earth Elemental in the Fractured Plains.",
        zone_id: 26,
        monster_id: 51,
        level_requirement: 28,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 58,
        name: "Fracture Beast Hide",
        type: "armor",
        atk: 0,
        def: 35,
        hp: 70,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.09,
        status_resist: 0.25,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 30,
        rarity: "Uncommon",
        lore: "Armor made from the hide of a Fracture Beast, tough and rugged.",
        zone_id: 26,
        monster_id: 52,
        level_requirement: 28,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 59,
        name: "Abyssal Staff",
        type: "weapon",
        atk: 35,
        def: 0,
        hp: 0,
        damage: 45,
        crit_chance: 0.16,
        crit_damage: 2.1,
        mana: 15,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 20,
        rarity: "Common",
        lore: "A staff echoing with abyssal cries, dropped by an Abyssal Echo in the Echoing Abyss.",
        zone_id: 27,
        monster_id: 53,
        level_requirement: 29,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 60,
        name: "Depth Lurker’s Claw",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 40,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A claw from a Depth Lurker, sharp and deadly.",
        zone_id: 27,
        monster_id: 54,
        level_requirement: 29,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 61,
        name: "Veil Overlord’s Blade",
        type: "weapon",
        atk: 50,
        def: 0,
        hp: 0,
        damage: 60,
        crit_chance: 0.20,
        crit_damage: 2.5,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 3,
        drop_chance: 0.15,
        ectoplasm_cost: 50,
        rarity: "Rare",
        lore: "A blade wielded by a Veil Overlord, pulsing with Veil energy.",
        zone_id: 28,
        monster_id: 55,
        level_requirement: 30,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 62,
        name: "Nexus Wraith’s Cloak",
        type: "armor",
        atk: 0,
        def: 40,
        hp: 80,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 10,
        max_mana: 0,
        dodge_chance: 0.10,
        status_resist: 0.25,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 35,
        rarity: "Uncommon",
        lore: "A cloak worn by a Nexus Wraith, shimmering with Veil energy.",
        zone_id: 28,
        monster_id: 56,
        level_requirement: 30,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 63,
        name: "Eternal Spear",
        type: "weapon",
        atk: 45,
        def: 0,
        hp: 0,
        damage: 55,
        crit_chance: 0.19,
        crit_damage: 2.3,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 25,
        rarity: "Common",
        lore: "A spear used by an Eternal Sentinel in the Guardian’s Ascent.",
        zone_id: 29,
        monster_id: 57,
        level_requirement: 31,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 64,
        name: "Spire Guardian’s Helm",
        type: "armor",
        atk: 0,
        def: 38,
        hp: 75,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.09,
        status_resist: 0.25,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 30,
        rarity: "Uncommon",
        lore: "A helm worn by a Spire Guardian, forged in the Eternal Spire.",
        zone_id: 29,
        monster_id: 58,
        level_requirement: 31,
        range: 0,
        equip_slot: "head",
      },
      {
        id: 65,
        name: "Storm Staff",
        type: "weapon",
        atk: 40,
        def: 0,
        hp: 0,
        damage: 50,
        crit_chance: 0.18,
        crit_damage: 2.2,
        mana: 15,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 25,
        rarity: "Common",
        lore: "A staff charged with storm energy, dropped by a Storm Wraith in the Tempest Plains.",
        zone_id: 30,
        monster_id: 59,
        level_requirement: 32,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 66,
        name: "Tempest Amulet",
        type: "accessory",
        atk: 0,
        def: 15,
        hp: 30,
        damage: 0,
        crit_chance: 0.10,
        crit_damage: 2.0,
        mana: 10,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.20,
        luck: 5,
        drop_chance: 0.2,
        ectoplasm_cost: 35,
        rarity: "Uncommon",
        lore: "An amulet charged with tempest energy, dropped by a Tempest Elemental.",
        zone_id: 30,
        monster_id: 60,
        level_requirement: 32,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 67,
        name: "Water Sprite Staff",
        type: "weapon",
        atk: 8,
        def: 0,
        hp: 0,
        damage: 12,
        crit_chance: 0.06,
        crit_damage: 1.5,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 6,
        rarity: "Common",
        lore: "A staff used by a Water Sprite in the Sacred Spring.",
        zone_id: 31,
        monster_id: 61,
        level_requirement: 5,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 68,
        name: "Lost Spirit’s Veil",
        type: "armor",
        atk: 0,
        def: 6,
        hp: 12,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.02,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 8,
        rarity: "Uncommon",
        lore: "A veil worn by a Lost Spirit, offering slight protection.",
        zone_id: 31,
        monster_id: 62,
        level_requirement: 5,
        range: 0,
        equip_slot: "head",
      },
      {
        id: 69,
        name: "Temple Dagger",
        type: "weapon",
        atk: 10,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.07,
        crit_damage: 1.6,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 8,
        rarity: "Common",
        lore: "A dagger used in rituals, dropped by a Temple Guardian in the Ruined Temple.",
        zone_id: 32,
        monster_id: 63,
        level_requirement: 7,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 70,
        name: "Sand Wraith’s Cloak",
        type: "armor",
        atk: 0,
        def: 8,
        hp: 15,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.03,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 10,
        rarity: "Uncommon",
        lore: "A cloak formed from sand, dropped by a Sand Wraith.",
        zone_id: 32,
        monster_id: 64,
        level_requirement: 7,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 71,
        name: "Bloodstone Sword",
        type: "weapon",
        atk: 12,
        def: 0,
        hp: 0,
        damage: 18,
        crit_chance: 0.08,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 10,
        rarity: "Common",
        lore: "A sword stained with bloodstone, dropped by a Bloodstone Hound in the Cursed Highlands.",
        zone_id: 33,
        monster_id: 65,
        level_requirement: 10,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 72,
        name: "Veil Stalker’s Fang",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 8,
        rarity: "Uncommon",
        lore: "A fang from a Veil Stalker, sharp and infused with Veil energy.",
        zone_id: 33,
        monster_id: 18,
        level_requirement: 10,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 73,
        name: "Thunder Bow",
        type: "weapon",
        atk: 25,
        def: 0,
        hp: 0,
        damage: 35,
        crit_chance: 0.14,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 18,
        rarity: "Common",
        lore: "A bow charged with lightning, dropped by a Thunder Elemental in the Thunder Peaks.",
        zone_id: 34,
        monster_id: 66,
        level_requirement: 18,
        range: 3,
        equip_slot: "main_hand",
      },
      {
        id: 74,
        name: "Storm Raven Feather",
        type: "accessory",
        atk: 0,
        def: 10,
        hp: 20,
        damage: 0,
        crit_chance: 0.08,
        crit_damage: 1.8,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.10,
        luck: 3,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A feather from a Storm Raven, charged with storm energy.",
        zone_id: 34,
        monster_id: 67,
        level_requirement: 18,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 75,
        name: "Veil Watcher’s Blade",
        type: "weapon",
        atk: 30,
        def: 0,
        hp: 0,
        damage: 40,
        crit_chance: 0.15,
        crit_damage: 2.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 20,
        rarity: "Common",
        lore: "A blade used by a Veil Watcher, infused with Veil energy.",
        zone_id: 35,
        monster_id: 68,
        level_requirement: 20,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 76,
        name: "Summit Shade’s Cloak",
        type: "armor",
        atk: 0,
        def: 28,
        hp: 55,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.07,
        status_resist: 0.20,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 25,
        rarity: "Uncommon",
        lore: "A cloak worn by a Summit Shade, infused with Veil energy.",
        zone_id: 35,
        monster_id: 69,
        level_requirement: 20,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 77,
        name: "Swamp Blade",
        type: "weapon",
        atk: 15,
        def: 0,
        hp: 0,
        damage: 20,
        crit_chance: 0.09,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 10,
        rarity: "Common",
        lore: "A blade rusted by the swamp, dropped by a Swamp Ghoul in the Fetid Mire.",
        zone_id: 36,
        monster_id: 70,
        level_requirement: 8,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 78,
        name: "Poison Frog Skin",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 8,
        rarity: "Uncommon",
        lore: "The toxic skin of a Poison Frog, found in the Dead Marshes.",
        zone_id: 36,
        monster_id: 71,
        level_requirement: 8,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 79,
        name: "Ghostlight Staff",
        type: "weapon",
        atk: 18,
        def: 0,
        hp: 0,
        damage: 25,
        crit_chance: 0.10,
        crit_damage: 1.8,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 12,
        rarity: "Common",
        lore: "A staff glowing with ghostly light, dropped by a Ghostlight Wisp in the Spectral Hollow.",
        zone_id: 37,
        monster_id: 72,
        level_requirement: 12,
        range: 2,
        equip_slot: "main_hand",
      },
      {
        id: 80,
        name: "Bog Specter’s Veil",
        type: "armor",
        atk: 0,
        def: 15,
        hp: 30,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.15,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "A veil worn by a Bog Specter, shimmering with ghostly energy.",
        zone_id: 37,
        monster_id: 73,
        level_requirement: 12,
        range: 0,
        equip_slot: "head",
      },
      {
        id: 81,
        name: "Veil Toad Tongue",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 20,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 10,
        rarity: "Common",
        lore: "A toxic tongue from a Veil Toad, found in the Mire Depths.",
        zone_id: 38,
        monster_id: 74,
        level_requirement: 13,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 82,
        name: "Swamp Lurker’s Hide",
        type: "armor",
        atk: 0,
        def: 18,
        hp: 35,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.15,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "Armor made from the hide of a Swamp Lurker, tough and slimy.",
        zone_id: 38,
        monster_id: 75,
        level_requirement: 13,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 83,
        name: "Bandit’s Dagger",
        type: "weapon",
        atk: 10,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.07,
        crit_damage: 1.6,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 8,
        rarity: "Common",
        lore: "A dagger used by a Bandit in the Trader’s Market.",
        zone_id: 39,
        monster_id: 76,
        level_requirement: 5,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 84,
        name: "Deserter’s Cloak",
        type: "armor",
        atk: 0,
        def: 6,
        hp: 12,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.02,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 8,
        rarity: "Uncommon",
        lore: "A cloak worn by a Deserter, tattered from years of hiding.",
        zone_id: 39,
        monster_id: 77,
        level_requirement: 5,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 85,
        name: "Scavenger’s Blade",
        type: "weapon",
        atk: 12,
        def: 0,
        hp: 0,
        damage: 18,
        crit_chance: 0.08,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 10,
        rarity: "Common",
        lore: "A blade scavenged from the Ashen Hollow, used by a Scavenger.",
        zone_id: 40,
        monster_id: 78,
        level_requirement: 6,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 86,
        name: "Ashen Armor",
        type: "armor",
        atk: 0,
        def: 8,
        hp: 15,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.03,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 10,
        rarity: "Uncommon",
        lore: "Armor patched together by a Scavenger, covered in ash.",
        zone_id: 40,
        monster_id: 78,
        level_requirement: 6,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 87,
        name: "Veil Stalker’s Claw",
        type: "weapon",
        atk: 25,
        def: 0,
        hp: 0,
        damage: 35,
        crit_chance: 0.14,
        crit_damage: 1.9,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 18,
        rarity: "Common",
        lore: "A claw weapon from a Veil Stalker, found in the Veilwatch Spire.",
        zone_id: 41,
        monster_id: 18,
        level_requirement: 15,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 88,
        name: "Veilwatch Ring",
        type: "accessory",
        atk: 0,
        def: 10,
        hp: 20,
        damage: 0,
        crit_chance: 0.08,
        crit_damage: 1.8,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.10,
        luck: 3,
        drop_chance: 0.2,
        ectoplasm_cost: 20,
        rarity: "Uncommon",
        lore: "A ring used by the ancient watchers of the Veilwatch Spire.",
        zone_id: 41,
        monster_id: 18,
        level_requirement: 15,
        range: 0,
        equip_slot: "ring",
      },
      {
        id: 89,
        name: "Cursed Skeleton Blade",
        type: "weapon",
        atk: 6,
        def: 0,
        hp: 0,
        damage: 10,
        crit_chance: 0.06,
        crit_damage: 1.5,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 5,
        rarity: "Common",
        lore: "A blade wielded by a Cursed Skeleton, imbued with dark magic.",
        zone_id: 1,
        monster_id: 3,
        level_requirement: 1,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 90,
        name: "Shattered Guard’s Shield",
        type: "armor",
        atk: 0,
        def: 5,
        hp: 10,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 6,
        rarity: "Uncommon",
        lore: "A broken shield once held by a Shattered Guard in the Entry Hall.",
        zone_id: 1,
        monster_id: 4,
        level_requirement: 1,
        range: 0,
        equip_slot: "off_hand",
      },
      {
        id: 91,
        name: "Crypt Skulker’s Dagger",
        type: "weapon",
        atk: 7,
        def: 0,
        hp: 0,
        damage: 12,
        crit_chance: 0.07,
        crit_damage: 1.6,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 5,
        rarity: "Common",
        lore: "A small dagger used by a Crypt Skulker for ambushes.",
        zone_id: 1,
        monster_id: 5,
        level_requirement: 1,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 92,
        name: "Bone Swarm Fragments",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 10,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 4,
        rarity: "Common",
        lore: "Fragments of a Bone Swarm, sharp and dangerous.",
        zone_id: 1,
        monster_id: 6,
        level_requirement: 1,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 93,
        name: "Fallen Soldier’s Armor",
        type: "armor",
        atk: 0,
        def: 6,
        hp: 12,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.01,
        status_resist: 0.05,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 6,
        rarity: "Uncommon",
        lore: "Armor worn by a Fallen Soldier, rusted but sturdy.",
        zone_id: 1,
        monster_id: 7,
        level_requirement: 1,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 94,
        name: "Skeletal Watcher’s Amulet",
        type: "accessory",
        atk: 0,
        def: 3,
        hp: 5,
        damage: 0,
        crit_chance: 0.05,
        crit_damage: 1.5,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.05,
        luck: 1,
        drop_chance: 0.15,
        ectoplasm_cost: 8,
        rarity: "Rare",
        lore: "An amulet worn by a Skeletal Watcher, glowing faintly.",
        zone_id: 1,
        monster_id: 8,
        level_requirement: 1,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 95,
        name: "Flooded Ghoul’s Blade",
        type: "weapon",
        atk: 12,
        def: 0,
        hp: 0,
        damage: 18,
        crit_chance: 0.08,
        crit_damage: 1.7,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 8,
        rarity: "Common",
        lore: "A blade carried by a Flooded Ghoul, rusted by water.",
        zone_id: 2,
        monster_id: 11,
        level_requirement: 6,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 96,
        name: "Abyssal Leech Essence",
        type: "consumable",
        atk: 0,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 6,
        rarity: "Common",
        lore: "Essence extracted from an Abyssal Leech, toxic to the touch.",
        zone_id: 2,
        monster_id: 12,
        level_requirement: 6,
        range: 2,
        equip_slot: "none",
      },
      {
        id: 97,
        name: "Spectral Drowner’s Cloak",
        type: "armor",
        atk: 0,
        def: 10,
        hp: 20,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.04,
        status_resist: 0.10,
        luck: 0,
        drop_chance: 0.2,
        ectoplasm_cost: 12,
        rarity: "Uncommon",
        lore: "A cloak worn by a Spectral Drowner, dripping with ghostly water.",
        zone_id: 2,
        monster_id: 13,
        level_requirement: 6,
        range: 0,
        equip_slot: "chest",
      },
      {
        id: 98,
        name: "Algae Wraith’s Amulet",
        type: "accessory",
        atk: 0,
        def: 5,
        hp: 10,
        damage: 0,
        crit_chance: 0.06,
        crit_damage: 1.6,
        mana: 5,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.10,
        luck: 2,
        drop_chance: 0.2,
        ectoplasm_cost: 15,
        rarity: "Uncommon",
        lore: "An amulet glowing with algae, dropped by an Algae Wraith.",
        zone_id: 2,
        monster_id: 14,
        level_requirement: 6,
        range: 0,
        equip_slot: "neck",
      },
      {
        id: 99,
        name: "Tidal Skeleton’s Spear",
        type: "weapon",
        atk: 10,
        def: 0,
        hp: 0,
        damage: 15,
        crit_chance: 0.07,
        crit_damage: 1.6,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.0,
        status_resist: 0.0,
        luck: 0,
        drop_chance: 0.3,
        ectoplasm_cost: 8,
        rarity: "Common",
        lore: "A spear wielded by a Tidal Skeleton, rusted by the floodwaters.",
        zone_id: 2,
        monster_id: 15,
        level_requirement: 6,
        range: 1,
        equip_slot: "main_hand",
      },
      {
        id: 100,
        name: "Deep Stalker’s Hide", 
        type: "armor",
        atk: 0,
        def: 12,
        hp: 25,
        damage: 0,
        crit_chance: 0.0,
        crit_damage: 0.0,
        mana: 0,
        max_mana: 0,
        dodge_chance: 0.05,
        status_resist: 0.10,
        luck: 0,
        drop_chance: 0.15,
        ectoplasm_cost: 15,
        rarity: "Rare",
        lore: "Armor made from the hide of a Deep Stalker, tough and water-resistant.",
        zone_id: 2,
        monster_id: 16,
        level_requirement: 6,
        range: 0,
        equip_slot: "chest",
      },
    ];